import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20geometric%20composition%20with%20warm%20golden%20and%20cream%20tones%2C%20flowing%20organic%20shapes%2C%20soft%20gradients%2C%20artistic%20background%20with%20subtle%20texture%2C%20clean%20elegant%20aesthetic%2C%20editorial%20design%20style%2C%20no%20text%2C%20no%20people&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape"
        alt="P站视频全攻略背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="animate-fade-in-up">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-500/90 text-background-50 mb-5">
            最全面的P站视频使用教程平台
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            P站视频全攻略
          </h1>
          <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
            从搜索技巧到高清下载，从分类浏览到收藏管理，一站式掌握P站视频的高效使用方式
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/sousuo-jiqiao"
              className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              开始学习
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category/xinren-rumen"
              className="px-6 py-3 rounded-full border border-background-300/60 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
            >
              新手入门指南
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-14 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          {[
            { value: '200+', label: '教程文章' },
            { value: '6', label: '分类体系' },
            { value: '50万+', label: '累计读者' },
            { value: '98%', label: '好评率' },
          ].map((stat) => (
            <div
              key={stat.label}
              className="bg-background-50/10 backdrop-blur-sm rounded-lg px-4 py-4 text-center border border-background-50/10"
            >
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-300">
                {stat.value}
              </div>
              <div className="text-xs text-background-300 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}